import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { free4uImg } from '../components/products/ProductCard/product-card.module.scss'

function Shipping(props) {
  return (
    <StaticImage
      className={free4uImg}
      src='../assets/images/free4u.png'
      alt='free shipping logo'
    />
  )
}

export default Shipping
